export const Durations = {
  off: "CUSTOMIZE",
  minutes15: "15 MINS",
  minutes30: "30 MINS",
  hour1: "1 HR",
};
